/**
 * Resaltado visual de citas pendientes cuyo teléfono tiene inasistencias previas.
 * Los campos booking_flag / booking_no_show_count vienen del API de citas.
 */

export const hasNoShowBookingWarning = (item) =>
  (item?.booking_flag === 'no_show_warning' || item?.booking_flag === 'transfer_required') &&
  String(item?.status || '') === 'pending';

export const appointmentRowHighlightClass = (appointment) => {
  if (!hasNoShowBookingWarning(appointment)) return '';
  if (appointment?.booking_flag === 'transfer_required') {
    return 'bg-amber-100/90 dark:bg-amber-950/50 ring-2 ring-inset ring-amber-500/75';
  }
  return 'bg-amber-50/90 dark:bg-amber-950/30 ring-2 ring-inset ring-amber-400/65';
};

export const eventCardHighlightClass = (event) => {
  const appt = event?.appointment || event;
  return hasNoShowBookingWarning(appt) ? 'ring-2 ring-amber-400/70' : '';
};

export const needsAttendanceConfirmation = (appointment) =>
  String(appointment?.status || '') === 'confirmed' &&
  Boolean((appointment?.daily_reminder_sent_on || '').trim()) &&
  !appointment?.daily_attendance_confirmed_at &&
  !appointment?.daily_attendance_auto_cancelled_at;

export function noShowBookingHint(appointment) {
  const n = appointment?.booking_no_show_count;
  if (!hasNoShowBookingWarning(appointment) || n == null) return '';
  if (appointment.booking_flag === 'transfer_required') {
    return `${n} inasistencia(s) — requiere transferencia al agendar`;
  }
  return `${n} inasistencia(s) previa(s) en este teléfono`;
}
